import {
  DatabaseBlockDataSource,
  ExternalGroupByConfigProvider,
} from '@blocksuite/affine/blocks/database';
import type { ExtensionType } from '@blocksuite/affine/store';
import { CalendarExternalSourceProvider } from '@blocksuite/data-view/view-presets';
import type { FrameworkProvider } from '@toeverything/infra';

import { createWorkspaceCalendarExternalSource } from '../../database-block/calendar/workspace-calendar-source';
import { groupByConfigList } from '../../database-block/group-by';
import { propertiesPresets } from '../../database-block/properties';
import { propriedadeEspecialDaFormula } from '../../database-block/properties/formula/calculadora';
// ⚠️ O tipo vem de `modelo`, que é quem o DECLARA — não da `calculadora`, que só o consome.
// A primeira versão o importava de lá e o build quebrou com `ESModulesLinkingError`: a
// `calculadora` importa o símbolo e não o reexporta. Importar de quem declara é o que impede
// a próxima pessoa de precisar descobrir por onde ele passou.
import { TIPO_DA_COLUNA_DE_FORMULA } from '../../database-block/properties/formula/modelo';
import { formulaPropertyConfig } from '../../database-block/properties/formula/view';

export function patchDatabaseBlockConfigService(
  framework?: FrameworkProvider
): ExtensionType {
  //TODO use service
  DatabaseBlockDataSource.externalProperties.value = [
    ...propertiesPresets,
    // ── TUNINHO: coluna de fórmula (card 1850168865112196130) ───────────────────────────
    //
    // Duas linhas num arquivo do upstream, e a lógica inteira em diretório próprio
    // (`database-block/properties/formula/`) — a forma que a Regra 8.15 do CLAUDE.md
    // estabelece: arquivo novo não conflita, arquivo editado conflita.
    //
    // O registro fica AQUI e não em `properties/index.ts` de propósito: as duas metades
    // (o tipo de coluna e a propriedade especial que a calcula) só funcionam juntas, e
    // separá-las em dois arquivos do upstream dobraria o custo do próximo update drill
    // para não ganhar nada.
    formulaPropertyConfig,
  ];

  // A metade que faz a coluna CALCULAR. Sem ela a coluna aparece no menu e toda célula fica
  // vazia: `rawValue.toJson`/`toString` não recebem `rowId`, então só `spacialValueGet` sabe
  // de que linha se trata. Ver o cabeçalho de `formula/define.ts`.
  DatabaseBlockDataSource.externalSpacialProperties.value = {
    [TIPO_DA_COLUNA_DE_FORMULA]: propriedadeEspecialDaFormula(),
  };
  return {
    setup: di => {
      groupByConfigList.forEach(config => {
        di.addValue(ExternalGroupByConfigProvider(config.name), config);
      });
      const source = createWorkspaceCalendarExternalSource(framework);
      di.addValue(CalendarExternalSourceProvider(source.id), source);
    },
  };
}
